import { ChevronLeft, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function TitleHeader({
  title,
  onClose,
}: {
  title?: string;
  onClose?: () => void;
}) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-background z-10 flex flex-col gap-0.5 px-6 pb-4 border-b-2 border-border">
      <div className="flex items-center justify-between h-12">
        <ChevronLeft onClick={handleGoBack} className="size-6 -ml-1 cursor-pointer" />
        {onClose && <X onClick={onClose} className="size-6 cursor-pointer" />}
      </div>
      <h1 className="font-medium text-left break-keep whitespace-pre-wrap">
        {title}
      </h1>
    </header>
  );
}
